import { Product } from '../../domain/types';
import { logger } from '../../infrastructure/logger';
import { productQueries } from './productQueries';

export class ProductStats {
  async getProductStats(partnerId: string): Promise<{
    totalProducts: number;
    activeProducts: number;
    pendingProducts: number;
    totalSales: number;
    totalViews: number;
  }> {
    try {
      const products = await productQueries.getProductsByPartner(partnerId);
      return {
        totalProducts: products.length,
        activeProducts: products.filter(p => p.status === 'active').length,
        pendingProducts: products.filter(p => p.approvalStatus === 'pending_review').length,
        totalSales: products.reduce((sum, p) => sum + (p.salesCount || 0), 0),
        totalViews: products.reduce((sum, p) => sum + (p.viewCount || 0), 0)
      };
    } catch (error) {
      logger.error('[ProductStats] Error fetching product stats', error);
      return {
        totalProducts: 0,
        activeProducts: 0,
        pendingProducts: 0,
        totalSales: 0,
        totalViews: 0
      };
    }
  }
}

export const productStats = new ProductStats();
